import axios, { AxiosResponse } from 'axios';
import authHeader from 'services/auth-header';
import { apiGet, apiPost } from './api';

export const getPartnersList = async ({ queryKey }: { queryKey: ["Partners", object] }) => {
    let paramData = queryKey[1];
    const data: { resultList: any[] } = await apiPost('/product/getProductB2BList', JSON.stringify(paramData));
    return data.resultList;
}

export const getPartnersProdList = async ({ queryKey }: { queryKey: ["PartnersProd", object] }) => {
    let paramData = queryKey[1];
    const data: { resultList: any[] } = await apiPost('/product/getPartnersProdList', JSON.stringify(paramData));
    return data.resultList;
}

